var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.98998 16L13 16C13.55 16 14 15.55 14 15C14 14.45 13.55 14 13 14L6.98998 14L6.98998 12.21C6.98998 11.76 6.44998 11.54 6.13998 11.86L3.35998 14.65C3.16998 14.85 3.16998 15.16 3.35998 15.36L6.13998 18.15C6.44998 18.47 6.98998 18.24 6.98998 17.8L6.98998 16ZM20.65 8.65003L17.86 5.86003C17.55 5.54003 17.01 5.76003 17.01 6.21003L17.01 8.00003L11 8.00003C10.45 8.00003 9.99998 8.45003 9.99998 9.00003C9.99998 9.55003 10.45 10 11 10L17.01 10L17.01 11.79C17.01 12.24 17.55 12.46 17.86 12.14L20.65 9.35003C20.84 9.16003 20.84 8.84003 20.65 8.65003Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionsIcon);
export default __webpack_public_path__ + "static/media/transactions-icon.0bde5a2fc48928101e29f6603d57c5bb.svg";
export { ForwardRef as ReactComponent };